import { SamplePack } from '@arpeggi/shared'
import { useMemo } from 'react'
import { TWEET_BASE_URL } from '../../../__legacy__/components/detail-pages/shared/TweetButton'

export const useSPTweet = (sp: SamplePack) => {
  const link = useMemo(() => {
    return encodeURI(
      TWEET_BASE_URL +
        `Check out ${sp.title} by ${
          sp.user.twitterHandle ? `@${sp.user.twitterHandle}` : sp.user.displayName
        } on @arpeggi_labs\n${window.location.origin}/sample-packs/${sp.id}`
    )
  }, [sp])
  const tweet = () => window.open(link, '_blank')
  return tweet
}
